module.exports = __webpack_public_path__ + "static/media/palette_from_example.66e9b63e.mov";